"use client";

import { trackEventOnClick } from "@faire/web/common/trackEvent";
import { Button } from "@faire/web/slate/Button";
import { StrictLocalMsg } from "@faire/web/ui/lib/localization";
import React from "react";

type Props = {
  blogCta: string;
  reviewerInfo: string;
  eventPrefix?: string;
};

export const BlogCtaButton: React.FC<Props> = ({
  blogCta,
  reviewerInfo,
  eventPrefix,
}) => {
  return (
    <Button
      variant="tertiary"
      linkTo={blogCta}
      onClick={trackEventOnClick(`${eventPrefix}${reviewerInfo}`)}
    >
      <StrictLocalMsg defaultMessage="Read Their Story" />
    </Button>
  );
};
